import React, { useState } from 'react';
import { TableCell, Stack, Tooltip, IconButton, Snackbar, Alert } from '@mui/material';
import {
    ChatBubbleOutline as ChatBubbleOutlineIcon,
    Email as EmailIcon,
    Info as InfoIcon,
    Phone as PhoneIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Worker } from '../../../models/worker';

/** Row actions: contact shortcuts plus worker detail and conversation navigation. */
const WorkerActionsCell: React.FC<{ worker: Worker }> = ({ worker }) => {
    const navigate = useNavigate();
    const [snackOpen, setSnackOpen] = useState(false);
    const [snackMessage, setSnackMessage] = useState('');

    const copyToClipboard = (value: string, label: string) => {
        navigator.clipboard.writeText(value);
        setSnackMessage(`${label} copied to clipboard!`);
        setSnackOpen(true);
    };

    return (
        <TableCell onClick={(e) => e.stopPropagation()}>
            <Stack direction="row" spacing={0.5}>
                <Tooltip title="Copy email">
                    <span>
                        <IconButton
                            size="small"
                            color={worker.emailAddress ? 'success' : 'default'}
                            disabled={!worker.emailAddress}
                            onClick={() => copyToClipboard(worker.emailAddress, 'Email')}
                        >
                            <EmailIcon fontSize="small" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Copy phone">
                    <span>
                        <IconButton
                            size="small"
                            color={worker.phoneNumber ? 'success' : 'default'}
                            disabled={!worker.phoneNumber}
                            onClick={() => copyToClipboard(worker.phoneNumber, 'Phone number')}
                        >
                            <PhoneIcon fontSize="small" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="View details">
                    <IconButton size="small" onClick={() => navigate(`/workers/${worker.workerId}`)} color="primary">
                        <InfoIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Open conversation">
                    <IconButton
                        size="small"
                        color="primary"
                        aria-label="Open conversation"
                        onClick={() => navigate(`/chat?workerId=${encodeURIComponent(worker.workerId)}`)}
                    >
                        <ChatBubbleOutlineIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            </Stack>

            <Snackbar
                open={snackOpen}
                autoHideDuration={2000}
                onClose={() => setSnackOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => setSnackOpen(false)} severity="success" sx={{ width: '100%' }}>
                    {snackMessage}
                </Alert>
            </Snackbar>
        </TableCell>
    );
};

export default WorkerActionsCell;
